
module Arkadium.Core {
	"use strict"

	export class ImplGoogle {
		private _appId: any;

		constructor(config){
			this._appId = config.google.gaId;

			const GA_MEASUREMENT_ID = config.google.gaId;
			var analyticsScript = window.document.createElement('script');
			analyticsScript.async = true;
			analyticsScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
			analyticsScript.setAttribute('crossorigin', 'anonymous');
			window.document.head.appendChild(analyticsScript);
		};

		init() {
			// @ts-ignore
			window.dataLayer = window.dataLayer || [];
			// Add cookie_flags for iframed games to be able to send events
			this.gtag('set', 'cookie_flags', 'SameSite=None;Secure');
			this.gtag('js', new Date());
			// Config GA4 GID
			this.gtag('config', this._appId);
			console.log("Google Analytics initialized using GTAG - GA4");
		};

		gtag(...args: any[]) {
			// @ts-ignore
			window.dataLayer.push(arguments);
		}

		logPageview(eventName, params) {
			// @ts-ignore
			this.gtag('event', 'page_view', {
				'send_to': this._appId,
				'page_title': params.title,
				'page_location': params.page
				});
		};
		
		logEvent(eventName, params) {
			// @ts-ignore
			this.gtag("event", eventName, {
				'send_to': this._appId,
			'event_category': params.category,
			'event_label': params.label,
			'action': params.action,
			'value': params.value
			});
		};
	}
}



// WEBPACK FOOTER //
// src/typescript/Core/Analytics/impl/ImplGoogle.ts